const ACTION =
  "https://images.unsplash.com/photo-1773949227239-43a2a537f104?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHx5b3V0aCUyMGxhY3Jvc3NlJTIwYWN0aW9uJTIwZGFya3xlbnwwfHx8fDE3NzkzMDAxMTB8MA&ixlib=rb-4.1.0&q=85";

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative min-h-[80vh] md:min-h-[90vh] overflow-hidden flex items-center"
    >
      <div className="absolute inset-0">
        <img
          src={ACTION}
          alt="Youth lacrosse action"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ filter: "grayscale(0.4) contrast(1.1)" }}
        />
        <div className="absolute inset-0 bg-black/70" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-black/40 to-transparent" />

        {/* Americana — horizontal red stripes fading across the section */}
        <div
          aria-hidden
          className="absolute inset-0 bse-stripes opacity-[0.09] pointer-events-none"
          style={{ maskImage: "linear-gradient(90deg, transparent 0%, #000 35%, #000 65%, transparent 100%)", WebkitMaskImage: "linear-gradient(90deg, transparent 0%, #000 35%, #000 65%, transparent 100%)" }}
        />
        {/* Star field on the right side over the photo */}
        <div
          aria-hidden
          className="absolute top-0 right-0 bottom-0 w-[40%] bse-stars opacity-[0.1] pointer-events-none"
          style={{ maskImage: "linear-gradient(270deg, #000 10%, transparent 100%)", WebkitMaskImage: "linear-gradient(270deg, #000 10%, transparent 100%)" }}
        />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-8 w-full">
        <div className="md:col-span-7">
          <div className="flex items-center gap-3 text-[10px] tracking-[0.3em] uppercase text-[#e11d2a] mb-6 reveal">
            <span className="inline-block w-8 h-px bg-[#e11d2a]" />
            <span>The Manifesto</span>
          </div>

          <h2 className="font-anton uppercase tracking-tight leading-[0.9] text-5xl sm:text-6xl md:text-7xl lg:text-8xl reveal">
            We don't just <br />
            <span className="text-[#e11d2a]">play the game.</span>
            <br />
            We set the tone.
          </h2>

          <div className="mt-10 max-w-xl space-y-4 text-neutral-300 text-base md:text-lg leading-relaxed reveal">
            <p>
              Big Stick Energy isn't a brag. It's a habit. Show up early. Run
              the line. Pick up the loose ball. Pick up your teammate.
            </p>
            <p className="text-neutral-400">
              We are eleven years old. We are not afraid of you. We will see
              you Saturday.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-3 max-w-lg border-t border-neutral-800 reveal">
            {[
              { k: "Speak", v: "Softly." },
              { k: "Carry", v: "Big." },
              { k: "Play", v: "Fearless." },
            ].map((p, i) => (
              <div
                key={i}
                className={`py-5 ${
                  i < 2 ? "border-r border-neutral-800" : ""
                }`}
              >
                <div className="text-[10px] tracking-[0.25em] uppercase text-neutral-500 mb-1">
                  {p.k}
                </div>
                <div className="font-anton text-2xl md:text-3xl text-white tracking-tight">
                  {p.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
